import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, NavParams, PopoverController, ToastController } from '@ionic/angular';
import { DelPopoverComponent } from 'src/app/shared/modals/popovers/del-popover/del-popover.component';
import { AccessControllerService, AccessSiteControllerService, DeviceControllerService } from 'src/app/shared/typescript-angular-client';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.page.html',
  styleUrls: ['./confirm-modal.page.scss'],
})
export class ConfirmModalPage implements OnInit {

  public accesses: Array<any> = [];
  public hasRadio = true;
  public siteId: number;
  public device: any;
  public accessIds: Array<number>;
  public subBtnClicked = false;
  public action: string;
  public i = 0;
  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public accessApi: AccessControllerService,
    public deviceApi: DeviceControllerService,
    public acessSiteApi: AccessSiteControllerService,
    public toast: ToastController,
    public navParams: NavParams,
    public modalController: ModalController,
    public popoverController: PopoverController
  ) {

  }

  ngOnInit() {
    // this.getSiteId();
    this.siteId = this.navParams.get('siteId');
    // this.accessIds = this.navParams.get('accessId');
    this.device = this.navParams.get('device');
    this.action = this.navParams.get('action');
  }

  ionViewWillEnter() {
    this.siteId = this.navParams.get('siteId');
    this.accesses = this.navParams.get('accesses');
    this.device = this.navParams.get('device');
    // this.acessSiteApi.accessSiteControllerSearchOtherSites(this.access.id).subscribe(
    //   res => {
    //     if (res) {
    //       this.access.properties.otherSites = true;
    //     }
    //   });
  }
  public async getSiteId() {
    this.accessIds = this.navParams.get('accessId');
    // this.activatedRoute.params.subscribe(async params => {
    //   this.siteId = params.siteId;
    console.log(this.accessIds);
    this.accesses = await this.accessApi.accessControllerFind().toPromise();
    this.accesses = this.accesses.filter(a => {
      let find = false;
      this.accessIds.forEach(id => {
        if (id === a.id) {
          find = true;
        }
      });
      return find;
    });
    // });
  }


  public radioSelect(event: any, access: any) {
    const radio = event.srcElement;
    if (radio.value === 'yes') {
      access.properties.delAll = true;
    } else {
      access.properties.delAll = false;
    }
  }

  async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: DelPopoverComponent,
      event: ev,
      showBackdrop: false,
      translucent: true
    });
    return await popover.present();
  }


  public async dismissModal(cancel = false): Promise<void> {
    this.modalController.getTop().then(
      modal => {
        if (modal !== undefined) {

          modal.dismiss({ cancel });
        }

      }
    );
  }

  public async submit() {
    this.subBtnClicked = true;
    switch (this.action) {
      case 'delete':
        this.accessDel();
        break;
      case 'add':
        this.accessActivate();
        break;

      default:
        break;
    }

  }


  private accessActivate() {
    if (this.accesses.length > 1) {
      this.deviceApi.deviceControllerCreateDeviceAccesses(this.device.id, this.accesses.map(a => a.id)).subscribe(res => {
        setTimeout(() => {
          this.toast.create({
            message: 'Commande d\'activation envoyée',
            duration: 3000,
            color: 'success',
            position: 'top'
          }).then((toastData) => {
            this.dismissModal();
            toastData.present();
          });
        }, 1000);
      });
    } else {
      this.deviceApi.deviceControllerCreateDeviceAccess(this.device.id, this.accesses.map(a => a.id)[0]).subscribe({
        next: () => {
          setTimeout(() => {
            this.toast.create({
              message: 'Commande d\'activation envoyée',
              duration: 3000,
              color: 'success',
              position: 'top'
            }).then((toastData) => {
              this.dismissModal();
              toastData.present();
            });
          }, 1000);
        },
        error: err => {
          this.toast.create({
            message: 'Une erreur s\'est produite lors de l\'activation du pass, merci de réessayer plus tard ',
            duration: 3000,
            color: 'danger',
            position: 'top'
          }).then((toastData) => {
            toastData.present();
            this.modalController.dismiss();
          });
        }
      });
    }
  }

  private accessDel() {
    if (this.accesses.length > 1) {
      this.deviceApi.deviceControllerDeleteDeviceAccesses(this.device.id, this.accesses.map(a => a.id)).subscribe(
        res => {
          setTimeout(() => {
            this.toast.create({
              message: 'Commande de désactivation envoyée',
              duration: 3000,
              color: 'success',
              position: 'top'
            }).then((toastData) => {
              this.dismissModal();
              toastData.present();
            });
          }, 1000);
        });
    } else {
      this.deviceApi.deviceControllerDeleteDeviceAccess(this.device.id, this.accesses.map(a => a.id)[0]).subscribe({
        next: () => {
          setTimeout(() => {
            this.toast.create({
              message: 'Commande de désactivation envoyée',
              duration: 3000,
              color: 'success',
              position: 'top'
            }).then((toastData) => {
              this.dismissModal();
              toastData.present();
            });
          }, 1000);
        },
        error: err => {
          this.toast.create({
            message: 'Une erreur s\'est produite lors de la désactivation du pass, merci de réessayer plus tard ',
            duration: 3000,
            color: 'danger',
            position: 'top'
          }).then((toastData) => {
            toastData.present();
            this.modalController.dismiss();
          });
        }
      });
    }
  }
}
